import { render, staticRenderFns } from "./LyndaAnswer.vue?vue&type=template&id=55ebd3f2"
import script from "./LyndaAnswer.vue?vue&type=script&lang=js"
export * from "./LyndaAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports